import { render } from "./dotsLoader.vue?vue&type=template&id=2503eaf7&scoped=true"
const script = {}

import "./dotsLoader.vue?vue&type=style&index=0&id=2503eaf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2503eaf7"]])

export default __exports__